<div fxLayout="column">
  <app-page-header [section]="'Pipeline'" [title]="'Explore your curated leads'" [description]="'This is your leads with all the retailers that applied to your retail offering categorised according to their qualification status.'"></app-page-header>

  <div class="page-padding page-content full-screen-height-page-default" fxLayout="column">

    <div fxFlexOffset="20px">
      <div fxLayout="row">
        <span class="subtitle-default">Statistics</span>
      </div>
    </div>

    <div fxLayout="row" fxFlexOffset="30px" fxLayoutGap="20px">

      <div class="info-card pt-3" fxLayout="row" fxLayoutGap="30px">

        <div class="full-width" fxLayout="column" fxLayoutGap="30px" fxFlex="35">

          <div class="full-width px-2" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="title-regular">Pipeline Overview</div>
            <mat-icon>more_vert</mat-icon>
          </div>


          <div class="dashboard-card full-width" fxLayout="column" fxLayoutGap="10px" fxFlexOffset="30px">
            <div class="dashboard-icon">
              <mat-icon class="material-icons-outlined">shopping_bag</mat-icon>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div class="subtitle-default">Pipeline</div>
              <div class="body-1-default">{{ approvedRetailers }}</div>
            </div>
            <div fxLayout="column" fxLayoutGap="5px">
              <mat-divider></mat-divider>
              <div class="body-1-regular-2">Amount of approved applications indicating good suitability</div>
            </div>
          </div>

          <div class="dashboard-card full-width" fxLayout="column" fxLayoutGap="10px">
            <div class="dashboard-icon">
              <mat-icon class="material-icons-outlined">store</mat-icon>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div class="subtitle-default">Rejected Applications</div>
              <div class="body-1-default">{{ rejectedRetailers }}</div>
            </div>
            <div fxLayout="column" fxLayoutGap="5px">
              <mat-divider></mat-divider>
              <div class="body-1-regular-2">Amount of rejected applications indicating poor suitability</div>
            </div>
          </div>
        </div>

        <div class="full-width" fxLayout="column" fxLayoutAlign="start end" fxFlex="65">
          <app-custom-date-filter [customDateRangePresets]="dateFilters"
                                  [initialPreset]="'last_month'"
                                  (dateRange)="getDateRange($event)"></app-custom-date-filter>

          <div class="full-width" fxFlexOffset="20px" style="height: 350px">
            <canvas  class="dashboard-canvas" baseChart *ngIf="!pipelineChartLoading; else canvasLoadingSpinner"
                     [data]="chartData"
                     [plugins]="barChartPlugins"
                     [options]="barChartOptions"
                     [type]="'bar'"></canvas>
          </div>

          <ng-template #canvasLoadingSpinner>
            <div fxLayout="row" fxLayoutAlign="center center" style="height: 350px">
              <mat-spinner color="primary" diameter="30"></mat-spinner>
            </div>
          </ng-template>

        </div>

      </div>

    </div>

    <mat-divider fxFlexOffset="30px"></mat-divider>

    <div fxFlexOffset="20px">
      <div fxLayout="row" fxLayoutGap="20px">
        <span class="subtitle-default">Pipeline</span>
        <button class="button-action" mat-flat-button
                (click)="openCreateLeaseTab()"
                [disabled]="loader.loading$ | async">
          <div class="button-text">Create a lease</div>
        </button>
      </div>
    </div>

    <div class="mat-elevation-z3 radius-10" fxLayout="column" fxFlexOffset="30px">
      <app-crud-table
        (rowSelected)="retailerSelectedForView($event)"
        [loading$]="loader.loading$"
        [modelType]="CrudRetailer"
        [tableData]="pipelineData"
        [title]="'Qualified applicants pipeline'"
      >
      </app-crud-table>
    </div>
  </div>

</div>
